// extracted by mini-css-extract-plugin
export default {"deleteBtn":"SiteAutoCompleteInput_deleteBtn_JbfiY","spinAround":"SiteAutoCompleteInput_spinAround__XNNa"};